import "./RegulatoryDisclosures.module.css";
import Header from "@/reusable_sections/Header";
import RegulatoryDisclosuresHero from "./sections/RegulatoryDisclosuresHero";
import Footer from "@/reusable_sections/Footer";
import Regulatorydisclosures from "./sections/Regulatorydisclosures";
import Compliancecertifications from "./sections/Compliancecertifications";
import Keyriskfactors from "./sections/Keyriskfactors";
import Compliancesupportcontact from "./sections/Compliancesupportcontact";
export default function RegulatoryDisclosuresPage() {
  return <div>
      <Header />
      <RegulatoryDisclosuresHero />
      <Regulatorydisclosures />
      <Compliancesupportcontact />
      <Compliancecertifications />
      <Keyriskfactors />
      <Footer />
    </div>;
}